import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import { useDarkMode } from '../../../contexts/DarkModeContext';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase';

const UserManagement = () => {
  const { isDarkMode } = useDarkMode();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const getAllUsers = httpsCallable(functions, 'getAllUsers');
      const result = await getAllUsers({ limit: 100 });
      setUsers(result.data.users);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          User Management
        </h1>
        <p className={`mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          View and manage app users
        </p>
      </div>

      <div className={`p-6 rounded-[24px] border ${
        isDarkMode ? 'bg-[#111111] border-gray-800' : 'bg-white border-gray-100'
      }`}>
        <div className="flex items-center gap-3 mb-4">
          <Users className={`w-5 h-5 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`} />
          <h2 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Total Users: {users.length}
          </h2>
        </div>

        <div className="space-y-2">
          {users.map(user => (
            <div
              key={user.uid}
              className={`p-4 rounded-xl ${isDarkMode ? 'bg-[#1A1A1A]' : 'bg-gray-50'}`}
            >
              <p className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {user.displayName || 'No name'}
              </p>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                {user.email}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
